<template>
  <v-dialog v-if="gamedata.rule === 'TEREM'" v-model="goalkeeperDialog" persistent max-width="820">
    <v-card tile flat>
      <v-card-title class="headline">Kapus kiválasztása</v-card-title>

      <v-card tile flat class="d-flex pa-4" :class="isMirrored ? 'flex-row-reverse': ''">
        <v-card tile flat class="width-100" :class="isMirrored ? 'pl-4': 'pr-4'">
          <v-card tile flat class="text-center">{{ gamedata.team_a_shortname }}</v-card>
          <v-select v-model="teamA.goalkeeper" class="width-100" return-object :items="getTeamGoalkeepers('A')"
                    item-text="name" label="Játékos" value="0"/>
        </v-card>
        <v-card tile flat class="width-100" :class="isMirrored ? 'pr-4': 'pl-4'">
          <v-card tile flat class="text-center">{{ gamedata.team_b_shortname }}</v-card>
          <v-select v-model="teamB.goalkeeper" class="width-100" return-object :items="getTeamGoalkeepers('B')"
                    item-text="name" label="Játékos" value="0"/>
        </v-card>
      </v-card>

      <v-card-actions>
        <v-spacer/>
        <v-btn depressed tile color="green" :disabled="!teamA.goalkeeper || !teamB.goalkeeper"
               @click="goalkeeperDialogHandle">Mentés
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

import {mapActions, mapGetters, mapMutations, mapState} from "vuex";
export default {
  props: {
    gamedata: Object,
    teamA: Object,
    teamB: Object,
  },
  methods: {
    ...mapMutations('ui', ['SET_GOALKEEPER_DIALOG',]),
    ...mapActions('game', ['updateGoalkeeper']),
    goalkeeperDialogHandle() {
      // Logika a store-ba került
      this.updateGoalkeeper({team: 'A', playerId: this.teamA.goalkeeper});
      this.updateGoalkeeper({team: 'B', playerId: this.teamB.goalkeeper});
      this.SET_GOALKEEPER_DIALOG(false);
    },
  },
  computed: {
    ...mapGetters('game', ['getTeamGoalkeepers']),
    ...mapState('ui', ['goalkeeperDialog', 'isMirrored']),
  }
}
</script>

<style scoped>

</style>
